module.exports = __webpack_public_path__ + "img/icone-quadrado-branco.8528cff2.png";